import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestHelper } from '@shared/helpers/request.helper';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class TaApiService {
    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}`;
    }

    // TAs
    getTas(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/tas`, { params: options });
    }

    updateTa(data: any): Observable<any> {
        return this.http.put(`${this.url}/tas`, data);
    }

    getTaOptions(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/tas`, { params: options });
    }

    // TA Cluster History
    getTaClusterHistories(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/ta-cluster-histories`, { params: options });
    }

    createTaClusterHistory(data: any): Observable<any> {
        return this.http.post(`${this.url}/ta-cluster-histories`, data);
    }

    updateTaClusterHistory(data: any): Observable<any> {
        return this.http.put(`${this.url}/ta-cluster-histories`, data);
    }

    // TA Availability History
    getTaAvailabilityHistories(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/ta-availability-histories`, { params: options });
    }

    createTaAvailabilityHistory(data: any): Observable<any> {
        return this.http.post(`${this.url}/ta-availability-histories`, data);
    }

    updateTaAvailabilityHistory(data: any): Observable<any> {
        return this.http.put(`${this.url}/ta-availability-histories`, data);
    }

    // TA Availability History - Self endpoints
    getTaAvailabilityHistoriesSelf(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/ta-availability-histories/self`, { params: options });
    }

    createTaAvailabilityHistorySelf(data: any): Observable<any> {
        return this.http.post(`${this.url}/ta-availability-histories/self`, data);
    }

    updateTaAvailabilityHistorySelf(data: any): Observable<any> {
        return this.http.put(`${this.url}/ta-availability-histories/self`, data);
    }

    // TA Training
    getTaTrainings(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/ta-trainings`, { params: options });
    }

    createTaTraining(data: any): Observable<any> {
        return this.http.post(`${this.url}/ta-trainings`, data);
    }

    updateTaTraining(data: any): Observable<any> {
        return this.http.put(`${this.url}/ta-trainings`, data);
    }

    // TA Shift Time
    getTaShiftTimes(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/ta-shift-times`, { params: options });
    }

    getTaShiftTimesSelf(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/ta-shift-times/self`, { params: options });
    }


    createTaShiftTime(data: any): Observable<any> {
        return this.http.post(`${this.url}/ta-shift-times`, data);
    }

    updateTaShiftTime(data: any): Observable<any> {
        return this.http.put(`${this.url}/ta-shift-times`, data);
    }

    commitTaShiftTime(data: any): Observable<any> {
        return this.http.put(`${this.url}/ta-shift-times/commit`, data);
    }

    deleteTaShiftTime(id: string, body?: any): Observable<any> {
        return this.http.put(`${this.url}/ta-shift-times/del/${id}`, body || {});
    }

    // Mark shift-time as absent
    absentTaShiftTime(id: string, body?: { note?: string }): Observable<any> {
        return this.http.put(`${this.url}/ta-shift-times/absent/${id}`, body || {});
    }


    // TA Shift Time Logs
    getTaShiftTimeLogOptions(req: PaginationRequest, body: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.post(`${this.url}/ta-shift-time-logs/`, body, { params: options });
    }


    // Update TA Shift Time Log note
    updateTaShiftTimeLogNote(data: { id: string; note: string | null }): Observable<any> {
        return this.http.put(`${this.url}/ta-shift-time-logs/`, data);
    }

}